import UserModel from 'core/src/models/user';
import SSView from 'core/src/views/base/ss-view';
import FollowUserButtonView from 'core/src/views/modules/buttons/follow-user-button';
import ClassesPopoverView from 'core/src/views/modules/classes-popover';
import ActionButtonTemplate from 'text!core/src/templates/custom-lists/action-button.mustache';
import UserListItemViewTemplate from 'text!core/src/templates/users/_list-row.mustache';

const UserListItemView = SSView.extend({

  tagName: 'div',

  className: 'user-list-row',

  template: UserListItemViewTemplate,

  templatePartials: {
    'custom-lists/action-button': ActionButtonTemplate
  },

  initialize: function() {
    this.listenTo(this.model, 'change:followingCircle', this.onFollowingCircleChange);
    this.followingCircle = this.model.get('followingCircle');

    SSView.prototype.initialize.apply(this, arguments);
  },

  templateData: function() {
    return _.extend(this.model.attributes, {
      hideAdminMenu: parseInt(this.model.get('uid'), 10) === parseInt(SS.currentUser.id, 10),
    });
  },

  onFollowingCircleChange: function() {
    this.render();
  },

  afterRender: function() {
    SSView.prototype.afterRender.apply(this, arguments);

    const userUid = parseInt(this.model.get('uid'), 10);
    const currentUserId = parseInt(SS.currentUser.id, 10);
    if (userUid !== currentUserId) {
      if (this.$('.follow-button-wrapper').length) {
        const followingId = this.model.get('followingCircle') ? this.model.get('followingCircle') : false;
        new FollowUserButtonView({
          container: this.$('.follow-button-wrapper'),
          classes: 'btn small',
          modelData: {
            user: new UserModel({ uid: userUid }),
            followingId: followingId,
            trackingParams: { via: 'user-list-row' },
          },
        });
      }

      this.actionMenu = new ClassesPopoverView({
        anchor: this.$('.list-item-action-btn'),
        el: this.$('.list-item-action-menu'),
        parentView: this,
      });
    }
  },
});

export default UserListItemView;

